import './styles.scss';
import API from '$vueCommon/classes/API.js';
import VueLD from '$vueCommon/VueLD.js';

if (import.meta.env.MODE === 'development') {
    require('../../sass/bootstrap.scss');
    require('../../sass/app.scss');
}

API.getTranslations().then(() => {
    initVueApps();
}).catch((error) => {
    console.error('Cannot load translations', error);
    initVueApps();
});

function initVueApps() {
    let vueAppContainer = document.getElementById('vue-app');
    if (!vueAppContainer) {
        return;
    }

    switch(vueAppContainer.dataset.target) {
        case 'cart':
            VueLD.createApp('Cart', '#vue-app'); break;
        case 'checkout':
            VueLD.createApp('Checkout', '#vue-app'); break;
    }
}
